import React, { useState } from 'react';
import DataTable from 'react-data-table-component';
import { ArrowLeftIcon, MagnifyingGlassIcon } from '@heroicons/react/24/outline';
import { Link } from 'react-router-dom';

const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
const logo = "/img/unemployment.png"

const columns = [
    {
        name: "Year",
        selector: row => row.year,
        sortable: true,
        cell: row => <span className="font-medium">{row.year}</span>
    },
    ...months.map(month => ({
        name: month,
        selector: row => row[month] || "-",
        sortable: true,
        cell: row => <span className={row[month] >= 10 ? 'text-red-600' : row[month] <= 3 ? 'text-green-600' : ''}>
            {row[month] ? `${row[month]}%` : "-"}
        </span>
    }))
];

const data = [
  {
    year: "2015",
    Jan: 3.5,
    Feb: 3.5,
    Mar: 3.5,
    Apr: 3.5,
    May: 3.5,
    Jun: 3.5,
    Jul: 3.5,
    Aug: 3.5,
    Sep: 3.5,
    Oct: 3.5,
    Nov: 3.5,
    Dec: 3.5,
  },
  {
    year: "2016",
    Jan: 3.5,
    Feb: 3.5,
    Mar: 3.5,
    Apr: 3.4,
    May: 3.4,
    Jun: 3.3,
    Jul: 3.3,
    Aug: 3.3,
    Sep: 3.2,
    Oct: 3.2,
    Nov: 3.2,
    Dec: 3.2,
  },
  {
    year: "2017",
    Jan: 3.2,
    Feb: 3.2,
    Mar: 3.2,
    Apr: 3.2,
    May: 3.2,
    Jun: 3.2,
    Jul: 3.2,
    Aug: 3.1,
    Sep: 3.1,
    Oct: 3.1,
    Nov: 3.1,
    Dec: 3.1,
  },
  {
    year: "2018",
    Jan: 3.0,
    Feb: 3.0,
    Mar: 3.0,
    Apr: 2.9,
    May: 2.9,
    Jun: 2.9,
    Jul: 2.9,
    Aug: 2.9,
    Sep: 2.9,
    Oct: 2.9,
    Nov: 2.9,
    Dec: 2.8,
  },
  {
    year: "2019",
    Jan: 2.8,
    Feb: 2.7,
    Mar: 2.7,
    Apr: 2.6,
    May: 2.6,
    Jun: 2.5,
    Jul: 2.5,
    Aug: 2.5,
    Sep: 2.4,
    Oct: 2.4,
    Nov: 2.4,
    Dec: 2.4,
  },
  {
    year: "2020",
    Jan: 2.5,
    Feb: 2.5,
    Mar: 2.5,
    Apr: 10.0,
    May: 7.7,
    Jun: 6.4,
    Jul: 5.7,
    Aug: 4.8,
    Sep: 4.5,
    Oct: 4.0,
    Nov: 3.8,
    Dec: 3.6,
  },
  {
    year: "2021",
    Jan: 3.4,
    Feb: 3.3,
    Mar: 3.1,
    Apr: 3.0,
    May: 2.9,
    Jun: 2.8,
    Jul: 2.7,
    Aug: 2.6,
    Sep: 2.5,
    Oct: 2.4,
    Nov: 2.3,
    Dec: 2.2,
  },
  {
    year: "2022",
    Jan: 2.2,
    Feb: 2.2,
    Mar: 2.3,
    Apr: 2.3,
    May: 2.3,
    Jun: 2.3,
    Jul: 2.4,
    Aug: 2.4,
    Sep: 2.5,
    Oct: 2.5,
    Nov: 2.5,
    Dec: 2.5,
  },
  {
    year: "2023",
    Jan: 2.5,
    Feb: 2.5,
    Mar: 2.5,
    Apr: 2.5,
    May: 2.6,
    Jun: 2.6,
    Jul: 2.7,
    Aug: 2.7,
    Sep: 2.8,
    Oct: 2.8,
    Nov: 2.9,
    Dec: 2.9,
  },
  {
    year: "2024",
    Jan: 2.9,
    Feb: 3.0,
    Mar: 3.0,
    Apr: 3.1,
    May: 3.2,
    Jun: 3.3,
    Jul: 3.3,
    Aug: 3.3,
    Sep: 3.3,
    Oct: 3.3,
    Nov: 3.3,
    Dec: 3.3,
  },
  {
    year: "2025",
    Jan: 3.2,
    Feb: 3.2,
    Mar: 3.1,
    Apr: 3.1,
    May: 3.2,
    Jun: 3.2,
    Jul: 3.3,
    Aug: null,
    Sep: null,
    Oct: null,
    Nov: null,
    Dec: null,
  },
];


const DataSet = () => {
    const [filterText, setFilterText] = useState('');

    const filteredData = data.filter(item =>
        item.year.includes(filterText) ||
        months.some(month =>
            item[month] && item[month].toString().includes(filterText)
        ));

    return (
        <div className="min-h-screen bg-gradient-to-b from-blue-50 to-white p-4 sm:p-6 lg:p-8">
            <div className="max-w-7xl mx-auto bg-white rounded-xl shadow-lg p-6">
                <div className="flex justify-between items-center mb-6">
                    <Link
                        to="/utah-at-a-glance/unemployment-rate"
                        className="flex items-center gap-2 text-blue-600 hover:text-blue-800"
                    >
                        <ArrowLeftIcon className="h-5 w-5" />
                        Back to Chart
                    </Link>
                    <h1 className="text-2xl sm:text-3xl font-bold text-center text-blue-900">
                        Unemployment Rate Dataset (2015-2025)
                    </h1>
                    <div className="w-24"></div> {/* Spacer for alignment */}
                </div>

                <div className="relative mb-6">
                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                        <MagnifyingGlassIcon className="h-5 w-5 text-gray-400" />
                    </div>
                    <input
                        type="text"
                        placeholder="Search year or value..."
                        className="block pl-10 pr-3 py-2 border border-gray-300 rounded-lg bg-white shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                        onChange={e => setFilterText(e.target.value)}
                    />
                </div>

                <DataTable
                    columns={columns}
                    data={filteredData}
                    pagination
                    highlightOnHover
                    responsive      
                    striped
                    customStyles={{
                        headCells: {
                            style: {
                                backgroundColor: '#1e40af',
                                color: 'white',
                                fontSize: '0.875rem',
                                fontWeight: '600',
                            },
                        },
                        cells: {
                            style: {
                                fontSize: '0.875rem',
                            },
                        },
                    }}
                />

                <div className="mt-6 flex items-center justify-center sm:justify-start">
                    <span className="text-sm text-gray-500 mr-2">Source:</span>
                    <img
                        src={logo}
                        alt="U.S. Bureau of Labor Statistics"
                        className="h-10 w-auto"
                    />
                    <span className="ml-2 text-sm text-gray-600">U.S. Bureau of Labor Statistics</span>
                </div>
            </div>
        </div>
    );
};

export default DataSet;